module.exports = __webpack_public_path__ + "static/_inkblot-logo-dark-bd48d4a467abcc0a328ef422dde0ec49.png";